// hardcoded-ui-text: allow — a console warning for whoever is developing, printed when the dev
// build points at the production project. Not part of any screen.
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://xgdotghvpryuxtoijakn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhnZG90Z2h2cHJ5dXh0b2lqYWtuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwOTA4ODksImV4cCI6MjA3MDY2Njg4OX0.rh0KDytv3Tyv0_FpvPFjQDjxBOVTVMYnsJtQSve1RkI";

// HARD BLOCK: prevent dev environment from EVER hitting production
if (import.meta.env.VITE_ENVIRONMENT === 'development' && SUPABASE_URL.includes('xgdotghvpryuxtoijakn')) {
  document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#7f1d1d;color:#fef2f2;font-family:monospace;text-align:center;padding:2rem"><div><h1 style="font-size:2rem;margin-bottom:1rem">🚨 BLOCKED: Dev → Production</h1><p style="font-size:1.1rem;max-width:600px">Dev environment is pointing to PRODUCTION Supabase.<br>Set <code style="background:#991b1b;padding:2px 6px;border-radius:4px">VITE_SUPABASE_URL</code> to the dev project URL in Vercel env vars.</p></div></div>';
  throw new Error('BLOCKED: Dev environment pointing to production Supabase (xgdotghvpryuxtoijakn). Fix VITE_SUPABASE_URL.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});